import {IStore} from "modules/types";

export const getBRSponsorModalStatus = ({modals}: IStore): boolean => modals.isOpenBRSponsorModal;
export const getOverrideModalState = ({modals}: IStore): boolean => modals.isOverrideModal;
